import { Reveal, SectionHead } from "./Reveal";

export default function WhoItsFor() {
    return (
        <section className="py-10 sm:py-14 lg:py-28">
            <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-2">
                <div>
                    <Reveal>
                        <SectionHead eyebrow="Is this you?" title="Who it's for" />
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-6 text-lg leading-relaxed text-ink-soft">
                            Fall Safe Ready is for adults 55 and older who live independently and want to stay
                            active, whether you&rsquo;ve had a fall, had a close call, or simply want to be
                            prepared. You don&rsquo;t need to be athletic. If you can stand up from a chair, with
                            or without using your arms, you can start. Many people begin in their 60s, while
                            they&rsquo;re strong enough to learn quickly.
                        </p>
                    </Reveal>
                    <Reveal delay={0.15}>
                        <p className="mt-8 font-display text-2xl font-extrabold leading-snug text-teal-700 sm:text-3xl">
                            Think of it as training, like learning to swim.
                        </p>
                    </Reveal>
                </div>
                <Reveal delay={0.1}>
                    <img
                        src="https://images.unsplash.com/photo-1758798458635-f01402b40919?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHw0fHxzZW5pb3JzJTIwZ3JvdXAlMjBleGVyY2lzZSUyMGNsYXNzJTIwc3RyZXRjaGluZ3xlbnwwfHx8fDE3OTI2OTA1ODV8MA&ixlib=rb-4.1.0&q=85"
                        alt="Adults in their 60s and 70s exercising together outdoors in a park"
                        className="aspect-[4/3] w-full rounded-[2rem] border border-clay object-cover"
                        loading="lazy"
                        data-testid="who-its-for-image"
                    />
                </Reveal>
            </div>
        </section>
    );
}